<textarea [value]="value" [hidden]="true"></textarea>
<textarea [id]="key + (ident ? ident : '')" class="wysiwyg"></textarea>